import { atom } from 'recoil';

export const sovDataState = atom({
  key: 'sovDataState', // unique ID
  default: {}, // default value
});